import {
  REQUEST_EXPERTISE_MISSIONS,
  SET_EXPERTISE_MISSIONS,
  REQUEST_UPDATE_MISSION_MANAGER,
  REQUEST_GET_CLAIM_INFO,
  SET_CLAIM_INFO,
  RESET_STORE_EXPERTISE,
} from 'containers/CourtManagerAssignedExpertise/constants';

export const requestExpertiseMissions = (payload: any) => ({
  type: REQUEST_EXPERTISE_MISSIONS,
  payload,
});

export const setExpertiseMissions = (payload: any) => ({
  type: SET_EXPERTISE_MISSIONS,
  payload,
});

export const requestUpdateMission = (
  payload: any,
  successCallback: Function,
) => {
  return {
    type: REQUEST_UPDATE_MISSION_MANAGER,
    payload,
    successCallback,
  };
};
export const requestGetClaimInfo = (payload: any) => {
  return {
    type: REQUEST_GET_CLAIM_INFO,
    payload,
  };
};
export const setClaimInfo = (payload: any) => {
  return {
    type: SET_CLAIM_INFO,
    payload,
  };
};
export const requestSetStoreExpertise = () => {
  return {
    type: RESET_STORE_EXPERTISE,
  };
};
